import React from 'react'
import { Col, Row } from 'antd'

const InfoItem = ({ label, value }) => (
  <Col span={8} style={{ marginBottom: 16, paddingRight: 16 }}>
    <div style={{ color: '#888', fontSize: 12 }}>{label}</div>
    <div style={{ fontWeight: 500 }}>{value || '—'}</div>
  </Col>
)

const GeneralInfoReadonly = ({ data }) => {
  const snapshot = data.order_snapshot || {}

  return (
    <div style={{ padding: '8px 0' }}>
      <Row>
        <InfoItem label="Código PCM" value={data.code} />
        <InfoItem label="Versão" value={data.version} />
        <InfoItem label="Pedido origem" value={data.order_code || snapshot.order_code} />
      </Row>
      <Row>
        <InfoItem label="Cliente" value={snapshot.name_client || snapshot.social_reason} />
        <InfoItem label="Obra" value={snapshot.name_work} />
        <InfoItem label="Cidade" value={snapshot.city_work} />
      </Row>
      <Row>
        <InfoItem label="Proposta" value={snapshot.proposal_code} />
        <InfoItem label="Total do pedido" value={snapshot.total} />
      </Row>
    </div>
  )
}

export default GeneralInfoReadonly
